import { render } from "./NewEntityForm.vue?vue&type=template&id=624da842&scoped=true"
import script from "./NewEntityForm.vue?vue&type=script&lang=js"
export * from "./NewEntityForm.vue?vue&type=script&lang=js"

import "./NewEntityForm.vue?vue&type=style&index=0&id=624da842&lang=css"
import "./NewEntityForm.vue?vue&type=style&index=1&id=624da842&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624da842"]])

export default __exports__